module.exports = __webpack_public_path__ + "img/kitchen_03.675ee1a4.png";